import { defineStore } from 'pinia'
import { ref } from 'vue'
import { adminLogin, type AdminLoginParams } from '@/api/admin'

export interface AdminInfo {
  id: number
  username: string
  name: string
  role: number
  referralCode: string | null
}

export const useAdminStore = defineStore('admin', () => {
  const token = ref<string | null>(localStorage.getItem('admin_token'))
  const adminInfo = ref<AdminInfo | null>(null)
  const loading = ref(false)

  const login = async (params: AdminLoginParams) => {
    loading.value = true
    try {
      const res = await adminLogin(params)
      if (res.data && res.data.result === 1) {
        token.value = res.data.data.token
        adminInfo.value = res.data.data.admin
        localStorage.setItem('admin_token', token.value!)
        localStorage.setItem('admin_info', JSON.stringify(adminInfo.value))
        return true
      }
      throw new Error(res.data?.msg || '登录失败')
    } finally {
      loading.value = false
    }
  }

  const logout = async () => {
    token.value = null
    adminInfo.value = null
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_info')
  }

  const initAdminInfo = () => {
    const savedInfo = localStorage.getItem('admin_info')
    if (savedInfo) {
      try {
        adminInfo.value = JSON.parse(savedInfo)
      } catch (e) {
        console.error('Failed to parse admin_info from localStorage')
      }
    }
  }

  // 初始化时加载信息
  initAdminInfo()

  return {
    token,
    adminInfo,
    loading,
    login,
    logout
  }
})
